import React from 'react';
import { SettingType } from '../../../../api/vault/publishEndpoints';
import { IProps } from './interfaces';
import {
  SocialDialog,
  SocialDialogHeader,
  SocialDialogTitle,
  SocialDialogActions,
  TitleField,
  DescriptionField,
} from '../../../Shared/Publish/SocialDialog';
import { DialogContentContainer } from '../../../Shared/styles/dialog';

const YouTubePublishDialog: React.FunctionComponent<IProps> = (props: IProps) => {
  const { onPublish } = props;

  return (
    <SocialDialog settingType={SettingType.YouTube}>
      <SocialDialogHeader>
        <SocialDialogTitle />
      </SocialDialogHeader>
      <DialogContentContainer>
        <TitleField />
        <DescriptionField />
      </DialogContentContainer>
      <SocialDialogActions onPublish={onPublish} isProcessing={false} setIsProcessing={(processing) => { }} />
    </SocialDialog>
  );
};

export default YouTubePublishDialog;
